(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 84375:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]/[hash]",
      function () {
        return __webpack_require__(51161);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IO": function() { return /* binding */ addFavorites; },
/* harmony export */   "OT": function() { return /* binding */ fetchFavorites; },
/* harmony export */   "fu": function() { return /* binding */ deleteFavorites; },
/* harmony export */   "uM": function() { return /* binding */ favoritesApi; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



// 즐겨찾기 리스트
var fetchFavorites = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, ref3, ref4, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FAVORITES */ .Z.FAVORITES).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.Rows,
                        count: res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.Data) === null || ref4 === void 0 ? void 0 : ref4.count
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchFavorites(body) {
        return _ref.apply(this, arguments);
    };
}();
// 즐겨찾기 등록
var addFavorites = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref5, ref6, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FAVORITES */ .Z.FAVORITES).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.Data,
                        msg: res === null || res === void 0 ? void 0 : (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.Data.Msg
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function addFavorites(body) {
        return _ref.apply(this, arguments);
    };
}();
// 즐겨찾기 삭제
var deleteFavorites = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref7, ref8, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FAVORITES */ .Z.FAVORITES).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref7 = res.data) === null || ref7 === void 0 ? void 0 : ref7.Data,
                        msg: res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : ref8.Data.Msg
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteFavorites(body) {
        return _ref.apply(this, arguments);
    };
}();
// 즐겨찾기 공통
var favoritesApi = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].FAVORITES */ .Z.FAVORITES).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function favoritesApi(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  & strong {\n    color: #e74c3c;\n  }\n\n  .modal-section {\n    width: fit-content;\n    background-color: white;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media (max-width: 767px) {\n      padding: 10px;\n    }\n    @media (max-width: 575px) {\n      padding: 10px;\n      width: 90vw;\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    & h5 {\n      font-size: 18px;\n      margin: 15px 0px;\n      & pre {\n        overflow: visible !important;\n        text-align: center;\n      }\n      @media (max-width: 575px) {\n        font-size: 1rem;\n      }\n    }\n    & img {\n      width: 75%;\n    }\n\n    & a {\n      margin-top: 20px;\n      width: 200px;\n    }\n\n    @media (max-width: 991px) {\n      & a {\n        width: 150px;\n      }\n    }\n    @media (max-width: 767px) {\n      & a {\n        width: 130px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-751e3b31-0"
})(_templateObject());
var InquiryCompleteModal = function(param) {
    var onClickInquiryComplete = param.onClickInquiryComplete, confirmText = param.confirmText, confirmImg = param.confirmImg;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiryComplete();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: confirmImg || "/assets/imgs/page/common/inquiry_complete_icon.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            children: confirmText || "\uC18C\uC911\uD55C \uC815\uBCF4 \uAC10\uC0AC\uD569\uB2C8\uB2E4!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "btn",
                            onClick: onClickInquiryComplete,
                            children: "\uC644\uB8CC"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InquiryCompleteModal);


/***/ }),

/***/ 51161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _hash_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/NumberCheck.js
var NumberCheck = __webpack_require__(55262);
;// CONCATENATED MODULE: ./hook/products/useProductPageTypeHandler.js



var useProductPageType = function() {
    var router = (0,next_router.useRouter)();
    var lastSlug = (0,react.useMemo)(function() {
        if (!router.isReady) return null;
        var pathSegments = router.asPath.split("/").filter(Boolean);
        return pathSegments[pathSegments.length - 1];
    }, [
        router.asPath,
        router.isReady
    ]);
    var isDetailPage = (0,react.useMemo)(function() {
        if (!lastSlug || !lastSlug.startsWith("P")) return false;
        var numberPart = lastSlug.slice(1);
        return (0,NumberCheck/* numberCheck */.M)(numberPart); // 숫자인지 확인
    }, [
        lastSlug
    ]);
    return {
        isDetailPage: isDetailPage,
        lastSlug: lastSlug
    };
};

// EXTERNAL MODULE: ./components/products/list/ProductsList.js + 7 modules
var ProductsList = __webpack_require__(18646);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./api/favorites.js
var favorites = __webpack_require__(14043);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./redux/action/cart.js
var cart = __webpack_require__(68866);
// EXTERNAL MODULE: ./components/products/detail/ProductDetails-styles.js
var ProductDetails_styles = __webpack_require__(26824);
;// CONCATENATED MODULE: ./components/products/detail/ProductTab.js




var ProductTab = function(param) {
    var product = param.product;
    var router = (0,next_router.useRouter)();
    var activeCertifications = [
        (product === null || product === void 0 ? void 0 : product.ecoLabelYn) === "Y",
        (product === null || product === void 0 ? void 0 : product.fscYn) === "Y",
        (product === null || product === void 0 ? void 0 : product.sfnzYn) === "Y", 
    ].filter(Boolean).length;
    var renderCertifications = activeCertifications > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* ProductTabWraper */.Nv, {
        children: [
            renderCertifications && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationContainer */.TQ, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationHeader */.Ny, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: "\uC0C1\uD488 \uC778\uC99D\uD604\uD669"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "\uC548\uC2EC\uD558\uACE0 \uC0AC\uC6A9\uC218 \uC788\uB3C4\uB85D \uC774 \uC0C1\uD488\uC774 \uD68D\uB4DD\uD55C \uACF5\uC2DD \uC778\uC99D\uC785\uB2C8\uB2E4."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationGrid */.nw, {
                        itemCount: activeCertifications,
                        children: [
                            (product === null || product === void 0 ? void 0 : product.ecoLabelYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationItem */.qX, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://file.caretbio.com/caretbio/40e8d6467e3b100b231f32c1c0232f77.png",
                                            alt: "\uD658\uACBD\uD45C\uC9C0\uC778\uC99D \uD655\uD2B9"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-name",
                                        children: "\uD658\uACBD\uD45C\uC9C0\uC778\uC99D \uD68D\uB4DD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-description",
                                        children: "\uAD6D\uAC00\uACF5\uC778 \uC778\uC99D\uAD8C \uC778\uC99D"
                                    })
                                ]
                            }),
                            (product === null || product === void 0 ? void 0 : product.fscYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationItem */.qX, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://file.caretbio.com/caretbio/90a455c40faad55e4482ac7e665fd033.png",
                                            alt: "FSC \uC778\uC99D \uD68D\uB4DD"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-name",
                                        children: "FSC \uC778\uC99D \uD68D\uB4DD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-description",
                                        children: "\uAE00\uB85C\uBC8C \uC778\uC99D\uAD8C \uC778\uC99D"
                                    })
                                ]
                            }),
                            (product === null || product === void 0 ? void 0 : product.sfnzYn) === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CertificationItem */.qX, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://file.caretbio.com/caretbio/852a28511e681460de2cf90fa473434a.png",
                                            alt: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uC778\uC99D \uD68D\uB4DD"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-name",
                                        children: "\uC2A4\uD15D\uD3EC\uB137\uC81C\uB85C \uC778\uC99D \uD68D\uB4DD"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cert-description",
                                        children: "\uD0C4\uC18C\uC800\uAC10 \uC778\uC99D"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* MoreButton */.zw, {
                        onClick: function() {
                            return router.push("/esg-guide/certification/");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            children: [
                                "\uB354 \uC54C\uC544\uBCF4\uAE30",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-angle-right"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* HtmlWrapper */.bR, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ck-content",
                        dangerouslySetInnerHTML: {
                            __html: product === null || product === void 0 ? void 0 : product.content
                        }
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var detail_ProductTab = (ProductTab);

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
;// CONCATENATED MODULE: ./components/sliders/Related.js




swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_
]);
var RelatedSlider = function(param) {
    var related = param.related;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                style: {
                    width: "100%"
                },
                slidesPerView: 2,
                spaceBetween: 30,
                navigation: {
                    prevEl: ".custom_prev_n",
                    nextEl: ".custom_next_n"
                },
                className: "custom-class",
                breakpoints: {
                    995: {
                        slidesPerView: 4
                    }
                },
                children: related === null || related === void 0 ? void 0 : related.map(function(product, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                            product: product
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "slider-arrow slider-arrow-2 carausel-6-columns-arrow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "slider-btn slider-prev slick-arrow custom_prev_n",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-angle-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "slider-btn slider-next slick-arrow custom_next_n",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-angle-right"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Related = (RelatedSlider);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75236);
;// CONCATENATED MODULE: ./components/sliders/Thumb.js






swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Thumbs */.o3
]);
var ThumbSlider = function(param) {
    var product = param.product;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), thumbsSwiper = ref2[0], setThumbsSwiper = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                style: {
                    "--swiper-navigation-color": "#ececec",
                    "--swiper-pagination-color": "#fff"
                },
                navigation: true,
                thumbs: {
                    swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                },
                className: "mySwiper2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mainImg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: product.main_image || "/assets/imgs/theme/logo.png"
                            })
                        })
                    }),
                    (ref = product.sub_image) === null || ref === void 0 ? void 0 : ref.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mainImg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: item
                                })
                            })
                        }, i);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                onSwiper: setThumbsSwiper,
                slidesPerView: 4,
                spaceBetween: 20,
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                className: "mySwiper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "subImg",
                            src: product.main_image
                        })
                    }),
                    (ref1 = product.sub_image) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "subImg",
                                src: item
                            })
                        }, i);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Thumb = (ThumbSlider);

// EXTERNAL MODULE: ./components/layout/Seo.js + 4 modules
var Seo = __webpack_require__(65250);
// EXTERNAL MODULE: ./redux/action/baskets.js
var baskets = __webpack_require__(83173);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/products/detail/inquiryModal.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 10000001;\n  width: 100vw;\n  height: 100vh;\n\n  & strong {\n    color: #e74c3c;\n  }\n\n  .select {\n    height: 38px;\n    border: 1px solid #ececec;\n    border-radius: 10px;\n    padding-left: 20px;\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n\n  .modal-section {\n    position: fixed;\n    top: 15vh;\n    left: 30vw;\n    width: 40vw;\n    height: 70vh;\n    background-color: white;\n    border-radius: 20px;\n    overflow: auto;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    & > i {\n      font-size: 2rem;\n      color: black;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n    @media screen and (max-width: 1199px) {\n      left: 25vw;\n      width: 50vw;\n    }\n    @media screen and (max-width: 767px) {\n      left: 15vw;\n      width: 70vw;\n    }\n    @media screen and (max-width: 575px) {\n      left: 10vw;\n      width: 80vw;\n    }\n  }\n\n  .modal-header {\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: black;\n    & i {\n      font-size: 26px !important;\n      color: #696969;\n      cursor: pointer;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .modal-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    border: none;\n    margin: 0 auto;\n    overflow-y: auto;\n    & > span {\n      color: black;\n    }\n  }\n  .inputWrapper {\n    width: 100%;\n    margin-bottom: 20px;\n\n    & h6 {\n      margin-bottom: 10px;\n    }\n    & input {\n      height: 38px;\n      margin-bottom: 10px;\n      ::placeholder {\n        font-size: 14px;\n        color: #6c757da5;\n      }\n      :focus {\n        border-color: #3bb77e !important;\n        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n      }\n    }\n    .col {\n      display: flex;\n      flex-direction: column;\n      width: 50%;\n      & input {\n        width: 100%;\n        padding-right: 0;\n      }\n    }\n    @media screen and (max-width: 575px) {\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      .row {\n        display: flex;\n        flex-direction: column;\n        .col {\n          width: 100%;\n        }\n      }\n    }\n  }\n  & textarea {\n    min-height: 150px;\n    ::placeholder {\n      font-size: 14px;\n      color: #6c757da5;\n    }\n    :focus {\n      border-color: #3bb77e !important;\n      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;\n    }\n  }\n  .btnWrapper {\n    width: 100%;\n    & button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  column-gap: 20px;\n  row-gap: 10px;\n  & input {\n    padding: 6px 5px;\n  }\n  @media screen and (max-width: 1200px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ModalWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3e14fe3-0"
})(_templateObject());
var FileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d3e14fe3-1"
})(_templateObject1());
var ProductInquiryModal = function(param) {
    var onClickInquiry = param.onClickInquiry, submitInquiry = param.submitInquiry, openInquiryModal = param.openInquiryModal, onChangeInquiry = param.onChangeInquiry, inquiryInputs = param.inquiryInputs;
    globalThis.onkeydown = function(e) {
        if (e.code === "Escape") return onClickInquiry();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            "\uC81C\uC791 & \uC0C1\uD488 \uBB38\uC758",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fi-rs-circle-cross",
                                onClick: onClickInquiry
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inputWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uBB38\uC758 \uBD84\uB958 ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "select mb-10",
                                                        defaultValue: "",
                                                        onChange: onChangeInquiry("division"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                disabled: true,
                                                                value: "",
                                                                children: "--\uC120\uD0DD\uD558\uC138\uC694--"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "M",
                                                                children: "\uC81C\uC791 \uBB38\uC758"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "Q",
                                                                children: "\uC0C1\uD488 \uBB38\uC758"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uD68C\uC0AC\uBA85"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("company")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uBB38\uC758\uC790 \uBA85 ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("name")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uBB38\uC758\uC790 \uC5F0\uB77D\uCC98 ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("tel")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uC774\uBA54\uC77C ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("email")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC778\uC1C4 \uC5EC\uBD80 "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex custome-radio justify-content-around align-items-center h-50",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: "d-none",
                                                                type: "radio",
                                                                id: "yes",
                                                                name: "printRadio",
                                                                value: "Y",
                                                                onChange: onChangeInquiry("printYn")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "yes",
                                                                children: "\uC608"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: "d-none",
                                                                type: "radio",
                                                                id: "no",
                                                                name: "printRadio",
                                                                value: "N",
                                                                onChange: onChangeInquiry("printYn")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label",
                                                                htmlFor: "no",
                                                                children: "\uC544\uB2C8\uC694"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC0AC\uC6A9\uCC98"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("usages")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "\uC218\uB7C9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "text",
                                                        onChange: onChangeInquiry("cnt")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: "\uBB38\uC758 \uB0B4\uC6A9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                        type: "text",
                                        onChange: onChangeInquiry("content"),
                                        placeholder: "\uBB38\uC758 \uB0B4\uC6A9\uC744 \uC790\uC138\uD558\uAC8C \uC785\uB825\uD574\uC8FC\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "\uCCA8\uBD80 \uD30C\uC77C"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FileWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file1")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file2")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "file",
                                                            className: "form-control",
                                                            onChange: onChangeInquiry("file3")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "btnWrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: submitInquiry,
                                    children: "\uBB38\uC758\uD558\uAE30"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var inquiryModal = (ProductInquiryModal);

// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./components/elements/requestLoginModal.js
var requestLoginModal = __webpack_require__(56177);
// EXTERNAL MODULE: ./api/order.js
var order = __webpack_require__(50059);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./common/util/getUserAgent.js
var getUserAgent = __webpack_require__(90481);
;// CONCATENATED MODULE: ./components/payment/Naverpay.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var PaymentNaverPay = function(param) {
    var product = param.product, cnt = param.cnt, loading = param.loading, _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, userDevice = param.userDevice;
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), isUser = ref1[0], setIsUser = ref1[1];
    var ref2 = (0,react.useState)(false), selectModal = ref2[0], setSelectModal = ref2[1];
    var naverpayCheckout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, UserAgent, widerplanet_device, ref, ref3, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _$isLoading();
                        _ctx.prev = 1;
                        body = {
                            modes: "OrderTemp",
                            naverYn: "Y",
                            items: JSON.stringify([
                                {
                                    pcode: product.pcode,
                                    cnt: cnt
                                }
                            ]),
                            flowCode: (0,auth/* getCookie */.ej)("NA_CO"),
                            clickId: (0,auth/* getCookie */.ej)("NVADID"),
                            slog: sessionStorage.getItem("slog") || "",
                            usepoint: 0,
                            coupon_code: "",
                            mobileYn: userDevice === "mobile" ? "Y" : "N"
                        };
                        _ctx.next = 5;
                        return (0,order/* StoreOrderApi */.RJ)(body);
                    case 5:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            UserAgent = (0,getUserAgent/* default */.Z)();
                            widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
                            if (widerplanet_device === "web") {
                                ;
                                window.open("https://order.pay.naver.com/customer/buy/".concat(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.sertParam));
                            }
                            if (widerplanet_device === "mobile") {
                                ;
                                router.push("https://m.pay.naver.com/o/customer/buy/".concat(res === null || res === void 0 ? void 0 : (ref3 = res.Data) === null || ref3 === void 0 ? void 0 : ref3.sertParam));
                            }
                            _$isLoaded();
                        } else {
                            ;
                            _$isLoaded();
                            (0,common_alert/* failAlert */.qh)(res === null || res === void 0 ? void 0 : (ref4 = res.Data) === null || ref4 === void 0 ? void 0 : ref4.Msg);
                        }
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        _$isLoaded();
                        alert(_ctx.t0.message);
                    case 13:
                        _$isLoaded();
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function naverpayCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    var naverpayZzim = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, UserAgent, widerplanet_device, ref6, ref7;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _$isLoading();
                        _ctx.prev = 1;
                        body = {
                            modes: "NaverInsertSet",
                            pcode: product.pcode
                        };
                        _ctx.next = 5;
                        return (0,favorites/* favoritesApi */.uM)(body);
                    case 5:
                        res = _ctx.sent;
                        if (!(res.Code == "0000")) {
                            _ctx.next = 15;
                            break;
                        }
                        ;
                        if (!((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Data.includes("<html>"))) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", alert("\uCC1C\uD558\uAE30\uC5D0 \uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4."));
                    case 10:
                        UserAgent = (0,getUserAgent/* default */.Z)();
                        widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
                        if (widerplanet_device === "web") {
                            ;
                            globalThis.open("https://pay.naver.com/customer/wishlistPopup.nhn?SHOP_ID=".concat("np_fcsnt894983", "&ITEM_ID=").concat((ref6 = res.Data) === null || ref6 === void 0 ? void 0 : ref6.Data), "_blank", "width=800,height=600");
                        }
                        if (widerplanet_device === "mobile") {
                            ;
                            router.push("https://m.pay.naver.com/mobile/customer/wishList.nhn?SHOP_ID=".concat("np_fcsnt894983", "&ITEM_ID=").concat((ref7 = res.Data) === null || ref7 === void 0 ? void 0 : ref7.Data));
                        }
                        _$isLoaded();
                    case 15:
                        _ctx.next = 21;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        alert(_ctx.t0.message);
                        _$isLoaded();
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function naverpayZzim() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if ((0,auth/* getCookie */.ej)("token")) {
            setIsUser(true);
        } else {
            setIsUser(false);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-flex justify-content-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "social-payment",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "naver-btn",
                            onClick: function() {
                                return setSelectModal(true);
                            },
                            style: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/imgs/product/payment_icon_naver.png",
                                    alt: "\uB124\uC774\uBC84\uD398\uC774 \uAD6C\uB9E4"
                                }),
                                "\uAD6C\uB9E4"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pick",
                            onClick: naverpayZzim,
                            children: "\uCC1C"
                        })
                    ]
                })
            }),
            selectModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* NPayModalWrapper */.DW, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "desc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "https://file.caretbio.com/caretbio/318411ad02c715642b18a63832b43268.png",
                                            alt: "naver_pay_info",
                                            width: 613,
                                            height: 359
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\uD68C\uC6D0\uAC00\uC785 \uD6C4 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uAD6C\uB9E4\uB97C \uC120\uD0DD\uD558\uC2DC\uBA74",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " \uCD5C\uB300 5\uB9CC\uC6D0 \uCFE0\uD3F0 \uC0AC\uC6A9\uACFC \uD3EC\uC778\uD2B8 \uC801\uB9BD \uBC0F \uC0AC\uC6A9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "*Npay \uB85C \uACB0\uC81C\uC2DC \uC0C1\uAE30 \uD61C\uD0DD\uC740 \uC801\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "btnWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cancel",
                                        onClick: function() {
                                            return setSelectModal(false);
                                        },
                                        children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uAD6C\uB9E4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "confirm",
                                        onClick: function() {
                                            return naverpayCheckout();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/product/payment_icon_naver.png",
                                                alt: "\uB124\uC774\uBC84\uD398\uC774 \uAD6C\uB9E4"
                                            }),
                                            "\uAD6C\uB9E4"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        loading: state.loading.loading
    };
};
var mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h
};
/* harmony default export */ var Naverpay = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PaymentNaverPay));

// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct-styles.js
var SingleProduct_styles = __webpack_require__(74971);
// EXTERNAL MODULE: ./redux/constants/actionTypes.js
var actionTypes = __webpack_require__(46330);
;// CONCATENATED MODULE: ./redux/action/userView.js

var insertVP = function(vp) {
    return function(dispatch) {
        dispatch({
            type: actionTypes/* USER_VIEW */.k6,
            payload: {
                vp: vp
            }
        });
    };
};

// EXTERNAL MODULE: ./components/mypage/coupon/couponModal.js
var coupon_couponModal = __webpack_require__(25994);
// EXTERNAL MODULE: ./components/products/list/TableTypeList.js
var TableTypeList = __webpack_require__(17461);
;// CONCATENATED MODULE: ./common/filter/filter.styles.js
function filter_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function filter_styles_templateObject() {
    var data = filter_styles_taggedTemplateLiteral([
        ""
    ]);
    filter_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function filter_styles_templateObject1() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n"
    ]);
    filter_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid #ececec;\n  :last-of-type {\n    border: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 160px;\n  padding: 10px;\n  background-color: #3bb77e;\n  color: #fff;\n\n  .expand {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  & li {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    position: relative;\n    & a {\n      color: #121212;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      padding: 0px 10px;\n      :hover {\n        text-decoration: underline !important;\n      }\n    }\n    .active {\n      background-color: #3bb77e;\n      color: #fff;\n      border-radius: 10px;\n    }\n    & span {\n      display: none;\n      justify-content: center;\n      align-items: center;\n      border-radius: 100%;\n      position: absolute;\n      top: 0px;\n      right: 0px;\n      background-color: #fff;\n      box-shadow: 0px 1px 1px #12121259;\n      color: #253d4e;\n      height: 15px;\n      width: 15px;\n      font-size: 8px;\n      padding: 8px;\n      border: 1px solid #ececec;\n      margin: 0px;\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n    :hover {\n      & span {\n        display: flex;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  .all {\n    min-width: 160px;\n    border-right: 1px solid #ececec;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    & a {\n      display: flex;\n      align-items: center;\n      padding: 10px;\n      cursor: pointer;\n\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: 5px;\n      }\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = filter_styles_taggedTemplateLiteral([
        '\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n\n  & li {\n    display: flex;\n    align-items: center;\n\n    & a {\n      color: #3bb77e !important;\n      font-weight: 500;\n      position: relative;\n      padding: 5px 10px;\n\n      ::after {\n        margin: 0px 5px;\n        content: "X";\n      }\n    }\n  }\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 50px;\n  border-top: 2px solid #121212;\n  border-bottom: 2px solid #121212;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  padding: 10px 0px;\n  border-bottom: 1px solid #ececec;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = filter_styles_taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 15%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 15%;\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .name {\n    }\n    .golgi {\n      width: 7%;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 25%;\n    }\n    .sizes {\n      display: none;\n    }\n    .strength {\n      width: 10%;\n    }\n    .feature {\n      width: 10%;\n    }\n    .golgi {\n    }\n    .onePrice {\n    }\n    .quantity {\n    }\n    .price {\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var FilterListSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-0"
})(filter_styles_templateObject());
// -------------------- filter ------------------------
var FilterWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-1"
})(filter_styles_templateObject1());
var FilterRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-2"
})(_templateObject2());
var FilterRowTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-3"
})(_templateObject3());
var FilterRowList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-4"
})(_templateObject4());
var FilteredListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-5"
})(_templateObject5());
var CheckedFilters = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-6"
})(_templateObject6());
// -------------------- list ------------------------
var ListWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-7"
})(_templateObject7());
var ListSortWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-8"
})(_templateObject8());
var ListViewTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-9"
})(_templateObject9());
var ListViewSelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-10"
})(_templateObject10());
var ProductsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-11"
})(_templateObject11());
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-12"
})(_templateObject12(), function(props) {
    return props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)";
});
var ProductsSignWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-13"
})(_templateObject13());
// table type list
var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-14"
})(_templateObject14());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-91adbd0c-15"
})(_templateObject15());

;// CONCATENATED MODULE: ./common/filter/filteredList.js





var FilteredList = function(props) {
    var viewType = props.viewType, handleListViewType = props.handleListViewType, dummyList = props.dummyList, filteredList = props.filteredList, purchaseDirect = props.purchaseDirect, handleCart = props.handleCart, inCart = props.inCart, fixedViewType = props.fixedViewType;
    var limit = 12;
    var max = 5;
    var ref = (0,react.useState)(1), currentPage = ref[0], setCurrentPage = ref[1];
    var pages = (0,react.useMemo)(function() {
        return filteredList && Math.ceil(filteredList.length / limit);
    }, [
        filteredList,
        limit
    ]);
    var startIndex = (0,react.useMemo)(function() {
        return (currentPage ? Number(currentPage) : 1) * limit - limit;
    }, [
        currentPage,
        limit
    ]);
    var endIndex = (0,react.useMemo)(function() {
        return startIndex + limit;
    }, [
        startIndex,
        limit
    ]);
    var start = (0,react.useMemo)(function() {
        return Math.floor(((currentPage || 1) - 1) / max) * max;
    }, [
        currentPage,
        max
    ]);
    var end = (0,react.useMemo)(function() {
        return start + max;
    }, [
        start,
        max
    ]);
    var pagination = (0,react.useMemo)(function() {
        return new Array(pages).fill().map(function(_, idx) {
            return idx + 1;
        });
    }, [
        pages
    ]);
    var getPaginationGroup = (0,react.useMemo)(function() {
        return pagination.slice(start, end);
    }, [
        pagination,
        start,
        max
    ]);
    var paginatedList = (0,react.useMemo)(function() {
        return (filteredList === null || filteredList === void 0 ? void 0 : filteredList.length) > 0 ? filteredList.slice(startIndex, endIndex) : [];
    }, [
        filteredList,
        startIndex,
        endIndex
    ]);
    // 페이지 네이션
    var next = function() {
        setCurrentPage(start + 6);
    };
    var prev = function() {
        setCurrentPage(start);
    };
    var handleActive = function(page) {
        setCurrentPage(page);
    };
    (0,react.useEffect)(function() {
        setCurrentPage(1);
    }, [
        filteredList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListSortWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewTypeWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "me-2",
                                    children: [
                                        "\uCD1D ",
                                        filteredList === null || filteredList === void 0 ? void 0 : filteredList.length,
                                        "\uAC1C\uC758 \uC0C1\uD488"
                                    ]
                                }),
                                !fixedViewType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewSelectBox, {
                                    listViewType: viewType ? viewType : "grid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: !viewType || viewType === "grid" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("grid");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-grid"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: viewType && viewType === "list" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("list");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-list"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsWrapper, {
                    children: [
                        (!viewType || viewType === "grid") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                            children: paginatedList && paginatedList.map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                        product: item,
                                        dummyList: dummyList,
                                        addCart: handleCart,
                                        inCart: inCart
                                    })
                                }, i);
                            })
                        }),
                        viewType && viewType === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTypeList/* default */.Z, {
                                productList: paginatedList,
                                dummyList: dummyList,
                                addCart: handleCart,
                                inCart: inCart,
                                viewFeature: false,
                                purchaseDirect: purchaseDirect
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pagination-area mb-15",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "Page navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "pagination justify-content-start",
                            children: [
                                start == 0 || getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: prev,
                                    className: "page-item",
                                    children: currentPage == 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-left"
                                        })
                                    })
                                }),
                                getPaginationGroup.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: function() {
                                            return handleActive(item);
                                        },
                                        className: currentPage == item ? "page-item active" : "page-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "page-link",
                                            children: item
                                        })
                                    }, index);
                                }),
                                getPaginationGroup.length <= 0 || pages <= 5 || end > pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: next,
                                    className: "page-item",
                                    children: currentPage >= pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-right"
                                        })
                                    })
                                }),
                                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "d-none d-md-flex align-items-center ml-10",
                                    children: [
                                        "\uCD1D ",
                                        pages,
                                        " \uD398\uC774\uC9C0"
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var filter_filteredList = (FilteredList);

// EXTERNAL MODULE: ./components/ecommerce/Filter/SizeFilter.js
var SizeFilter = __webpack_require__(82763);
;// CONCATENATED MODULE: ./common/filter/filter.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







// 라우팅 없는 필터 생성
var Filter = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var _$ref9, _$ref1, _$ref2, _$ref3;
    var dummyList = props.dummyList, productList = props.productList, fixedViewType = props.fixedViewType, purchaseDirect = props.purchaseDirect, handleCart = props.handleCart, basketsItems = props.basketsItems, cartItems = props.cartItems, product1 = props.product;
    var router = (0,next_router.useRouter)();
    var _$ref4 = (0,react.useState)(null), filteredList = _$ref4[0], setFilteredList = _$ref4[1];
    var _$ref5 = (0,react.useState)({}), filters = _$ref5[0], setFilters = _$ref5[1];
    var _$ref6 = (0,react.useState)({}), activeFilter = _$ref6[0], setActiveFilter = _$ref6[1];
    var _$ref7 = (0,react.useState)(""), viewType = _$ref7[0], setViewType = _$ref7[1];
    // 카테고리별 세부 카테고리를 저장할 상태 추가
    var _$ref8 = (0,react.useState)({}), categoryTagMap = _$ref8[0], setCategoryTagMap = _$ref8[1];
    var handleListViewType = function(type) {
        if (viewType === type) {
            return;
        }
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    // 필터
    var handleFilter = function(type, value) {
        if (type === "sizes") {
            var sizes = activeFilter.sizes, rest = _objectWithoutProperties(activeFilter, [
                "sizes"
            ]);
            setActiveFilter(_objectSpread({}, rest));
            return;
        }
        // reset 처리 추가
        if (type === "reset") {
            setActiveFilter({});
            return;
        }
        var prevQuery = activeFilter[type];
        var query = "";
        if (prevQuery && prevQuery.split(" ").includes(value)) {
            var tempArr = prevQuery.split(" ");
            var idx = prevQuery.split(" ").findIndex(function(el) {
                return el === value;
            });
            tempArr.splice(idx, 1);
            query = "".concat(tempArr.join(" "));
        } else {
            if (activeFilter[type]) {
                query = "".concat(prevQuery, " ").concat(value);
            } else {
                query = value;
            }
        }
        // 카테고리 변경 시 세부 카테고리 리셋
        if (type === "category_code") {
            // 카테고리가 완전히 비워졌는지 체크
            if (query === "") {
                var _obj;
                setActiveFilter(_objectSpread({}, activeFilter, (_obj = {}, _defineProperty(_obj, type, query), _defineProperty(_obj, "category_tag", ""), _obj)));
            } else {
                var _obj1;
                setActiveFilter(_objectSpread({}, activeFilter, (_obj1 = {}, _defineProperty(_obj1, type, query), _defineProperty(_obj1, "category_tag", ""), _obj1)));
            }
        } else {
            if (!activeFilter[type]) {
                setActiveFilter(_objectSpread({}, activeFilter, _defineProperty({}, type, value)));
            } else {
                setActiveFilter(_objectSpread({}, activeFilter, _defineProperty({}, type, query)));
            }
        }
    };
    // 필터 만들기
    var getFilters = function() {
        var _$ref;
        var productsCate = [];
        var categoryFilter = {
            type: "category_code",
            name: "\uCE74\uD14C\uACE0\uB9AC",
            values: []
        };
        // 카테고리별 세부 카테고리 매핑 생성
        var categoryTagMapping = {};
        productList.forEach(function(el) {
            if (!productsCate.includes(el.category_code)) {
                productsCate.push(el.category_code);
                categoryTagMapping[el.category_code] = [];
            }
            // 해당 카테고리의 세부 카테고리 태그들 수집
            if (el.category_tag) {
                var tags = el.category_tag.split(",");
                tags.forEach(function(tag) {
                    if (!categoryTagMapping[el.category_code].includes(tag)) {
                        categoryTagMapping[el.category_code].push(tag);
                    }
                });
            }
        });
        // 카테고리별 세부 카테고리 저장
        setCategoryTagMap(categoryTagMapping);
        var categories = dummyList === null || dummyList === void 0 ? void 0 : (_$ref = dummyList.category) === null || _$ref === void 0 ? void 0 : _$ref.filter(function(el) {
            return productsCate.includes(el.code);
        });
        if (categories) {
            categoryFilter = {
                type: "category_code",
                name: "\uCE74\uD14C\uACE0\uB9AC",
                values: categories.map(function(el) {
                    return {
                        name: el.name,
                        value: el.code
                    };
                })
            };
        }
        // 세부 카테고리 필터 생성 (초기에는 모든 세부 카테고리 표시)
        var allCategoryTags = [];
        Object.values(categoryTagMapping).forEach(function(tags) {
            tags.forEach(function(tag) {
                if (!allCategoryTags.includes(tag)) {
                    allCategoryTags.push(tag);
                }
            });
        });
        var categoryTagFilter = {
            type: "category_tag",
            name: "\uC138\uBD80 \uCE74\uD14C\uACE0\uB9AC",
            values: allCategoryTags.map(function(el) {
                return {
                    name: el,
                    value: el
                };
            })
        };
        setFilters(_objectSpread({}, filters, {
            category_code: categoryFilter,
            category_tag: categoryTagFilter
        }));
    };
    // 현재 선택된 카테고리에 해당하는 세부 카테고리 필터 가져오기
    var getFilteredCategoryTags = function() {
        var selectedCategory = activeFilter["category_code"];
        // 선택된 카테고리가 없으면 모든 세부 카테고리 반환
        if (!selectedCategory) {
            var allTags = [];
            Object.values(categoryTagMap).forEach(function(tags) {
                tags.forEach(function(tag) {
                    if (!allTags.includes(tag)) {
                        allTags.push(tag);
                    }
                });
            });
            return {
                type: "category_tag",
                name: "\uC138\uBD80 \uCE74\uD14C\uACE0\uB9AC",
                values: allTags.map(function(tag) {
                    return {
                        name: tag,
                        value: tag
                    };
                })
            };
        }
        // 선택된 카테고리의 세부 카테고리만 필터링
        var selectedCategories = selectedCategory.split(" ");
        var filteredTags = [];
        selectedCategories.forEach(function(category) {
            if (categoryTagMap[category]) {
                categoryTagMap[category].forEach(function(tag) {
                    if (!filteredTags.includes(tag)) {
                        filteredTags.push(tag);
                    }
                });
            }
        });
        return {
            type: "category_tag",
            name: "\uC138\uBD80 \uCE74\uD14C\uACE0\uB9AC",
            values: filteredTags.map(function(tag) {
                return {
                    name: tag,
                    value: tag
                };
            })
        };
    };
    // active 필터 적용
    var filtering = function() {
        if (Object.keys(activeFilter) && Object.values(activeFilter).filter(function(el) {
            return el != "";
        }).length > 0) {
            var query = activeFilter;
            var filterKeys = Object.keys(activeFilter);
            var tempList = productList;
            filterKeys.map(function(key) {
                if (!query[key]) return;
                tempList = tempList.filter(function(el) {
                    if (!query[key]) return;
                    if (key === "sizes") {
                        var _$ref = JSON.parse(query.sizes), height = _$ref.height, horizontal = _$ref.horizontal, range = _$ref.range, vertical = _$ref.vertical;
                        if (horizontal > 0 && Number(horizontal) - Number(range) <= Number(el.horizontal) && Number(el.horizontal) <= Number(horizontal) + Number(range) || vertical > 0 && Number(vertical) - Number(range) <= Number(el.vertical) && Number(el.vertical) <= Number(vertical) + Number(range) || height > 0 && Number(height) - Number(range) <= Number(el.height) && Number(el.height) <= Number(height) + Number(range)) {
                            return el;
                        }
                    } else if (key === "category_tag" && el[key].split(",").includes(query[key])) {
                        return el;
                    } else if (query[key].split(" ").includes(el[key])) {
                        return el;
                    } else {
                        return;
                    }
                });
            });
            setFilteredList(tempList);
        } else {
            setFilteredList(productList);
        }
    };
    var handleSizeFilter = function(sizes) {
        var height = sizes.height, horizontal = sizes.horizontal, range = sizes.range, vertical = sizes.vertical;
        if (sizes) {
            setActiveFilter(_objectSpread({}, activeFilter, {
                sizes: JSON.stringify(sizes)
            }));
        }
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        if (!(0,auth/* getCookie */.ej)("token")) {
            return cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
                return cartItem.pcode === product.pcode;
            });
        } else {
            return basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
                return basketsItem.pcode === product.pcode;
            });
        }
    };
    (0,react.useEffect)(function() {
        filtering();
    }, [
        activeFilter,
        productList
    ]);
    (0,react.useEffect)(function() {
        if (!productList || !dummyList) return;
        getFilters();
        if (fixedViewType) {
            setViewType(fixedViewType);
        }
    }, [
        productList,
        dummyList,
        fixedViewType
    ]);
    // 외부에서 접근 가능한 함수 정의
    (0,react.useImperativeHandle)(ref, function() {
        return {
            handleFilterClick: function(type, value) {
                handleFilter(type, value);
            }
        };
    });
    // 초기 필터 자동 세팅을 위한 함수
    var setInitialFilters = function() {
        if (!product1 || !filters) return;
        var initialFilter = {};
        // category_code 자동 세팅
        if (product1.category_code && filters.category_code) {
            // category_code가 문자열이므로 직접 비교
            var matchingCategory = filters.category_code.values.find(function(val) {
                return val.name === product1.category_code;
            });
            if (matchingCategory) {
                // value 값으로 필터 세팅
                initialFilter.category_code = matchingCategory.value;
            }
        }
        // category_tag 자동 세팅
        if (product1.category_tag && filters.category_tag) {
            // 첫 번째 태그를 기본값으로 사용
            var firstTag = Array.isArray(product1.category_tag) ? product1.category_tag[0] : product1.category_tag.split(",")[0];
            var matchingTag = filters.category_tag.values.find(function(val) {
                return val.value === firstTag;
            });
            if (matchingTag) {
                initialFilter.category_tag = firstTag;
            }
        }
        // 초기 필터 값 설정
        if (Object.keys(initialFilter).length > 0) {
            setActiveFilter(initialFilter);
        }
    };
    // 필터 생성 후 초기 필터 세팅
    (0,react.useEffect)(function() {
        if (Object.keys(filters).length > 0 && product1) {
            setInitialFilters();
        }
    }, [
        filters,
        product1
    ]);
    // 현재 선택된 카테고리에 따라 필터링된 세부 카테고리 가져오기
    var filteredCategoryTags = getFilteredCategoryTags();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((_$ref9 = Object.keys(filters)) === null || _$ref9 === void 0 ? void 0 : _$ref9.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterWrapper, {
                children: [
                    filters.category_code && ((_$ref1 = filters.category_code.values) === null || _$ref1 === void 0 ? void 0 : _$ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                                children: filters.category_code.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                                children: filters.category_code.values.map(function(row, rowIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            onClick: function() {
                                                return handleFilter(filters.category_code.type, row.value);
                                            },
                                            className: "".concat(activeFilter[filters.category_code.type] && activeFilter[filters.category_code.type].includes(row.value) && "active"),
                                            children: [
                                                row.name,
                                                activeFilter[filters.category_code.type] && activeFilter[filters.category_code.type].includes(row.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fi-rs-cross"
                                                    })
                                                })
                                            ]
                                        })
                                    }, rowIdx);
                                })
                            })
                        ]
                    }),
                    ((_$ref2 = filteredCategoryTags.values) === null || _$ref2 === void 0 ? void 0 : _$ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                                children: filteredCategoryTags.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                                children: filteredCategoryTags.values.map(function(row, rowIdx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            onClick: function() {
                                                return handleFilter(filteredCategoryTags.type, row.value);
                                            },
                                            className: "".concat(activeFilter[filteredCategoryTags.type] && activeFilter[filteredCategoryTags.type].includes(row.value) && "active"),
                                            children: [
                                                row.name,
                                                activeFilter[filteredCategoryTags.type] && activeFilter[filteredCategoryTags.type].includes(row.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fi-rs-cross"
                                                    })
                                                })
                                            ]
                                        })
                                    }, rowIdx);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                                children: "\uC0AC\uC774\uC988"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex p-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeFilter/* default */.Z, {
                                        handleSizeFilter: handleSizeFilter,
                                        viewHeight: true,
                                        selectedCategory: activeFilter.category_code
                                    })
                                })
                            })
                        ]
                    }),
                    activeFilter && Object.values(activeFilter).filter(function(el) {
                        return el != "";
                    }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilteredListWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "all",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    onClick: function() {
                                        setActiveFilter({});
                                    },
                                    children: [
                                        "\uC804\uCCB4 \uD574\uC81C ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-rotate-left"
                                        }),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedFilters, {
                                children: ((_$ref3 = Object.keys(activeFilter)) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) > 0 && Object.keys(activeFilter).map(function(query) {
                                    if (query !== "sizes") {
                                        if (query === "category_code") {
                                            var _$ref;
                                            return (_$ref = filters[query]) === null || _$ref === void 0 ? void 0 : _$ref.values.map(function(value, vIdx) {
                                                if (activeFilter[query].split(" ").includes(value.value)) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        onClick: function() {
                                                            return handleFilter(query, value.value);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: value.name
                                                        })
                                                    }, vIdx);
                                                } else {
                                                    return "";
                                                }
                                            });
                                        } else if (query === "category_tag") {
                                            return filteredCategoryTags.values.map(function(value, vIdx) {
                                                if (activeFilter[query].split(" ").includes(value.value)) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        onClick: function() {
                                                            return handleFilter(query, value.value);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: value.name
                                                        })
                                                    }, vIdx);
                                                } else {
                                                    return "";
                                                }
                                            });
                                        }
                                    } else {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: function() {
                                                return handleFilter(query, "");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "\uC0AC\uC774\uC988 \uD544\uD130"
                                            })
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(filter_filteredList, {
                viewType: viewType,
                handleListViewType: handleListViewType,
                dummyList: dummyList,
                filteredList: filteredList,
                purchaseDirect: purchaseDirect,
                handleCart: handleCart,
                inCart: inCart,
                fixedViewType: fixedViewType
            })
        ]
    });
});
Filter.displayName = "Filter";
/* harmony default export */ var filter = (Filter);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/helper.js
var helper = __webpack_require__(11769);
;// CONCATENATED MODULE: ./style/fontStyle.js
function fontStyle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function fontStyle_templateObject() {
    var data = fontStyle_taggedTemplateLiteral([
        "\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 10px;\n"
    ]);
    fontStyle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// h4인 태그 스타일 적용
var H1Font = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-e4ae8004-0"
})(fontStyle_templateObject());

// EXTERNAL MODULE: ./redux/action/quickViewAction.js
var quickViewAction = __webpack_require__(43181);
// EXTERNAL MODULE: ./components/sliders/Category.js
var Category = __webpack_require__(64728);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/products/detail/ProductsDetail.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ProductsDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsDetail_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsDetail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsDetail_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProductsDetail_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsDetail_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







































var ProductsDetail = function(props) {
    var ref14, ref1, ref2;
    var product1 = props.product, quickView = props.quickView, cartItems = props.cartItems, _$addToCart = props.addToCart, _$insertBasketsAction = props.insertBasketsAction, basketsItems = props.basketsItems, userDevice = props.userDevice, _$isLoading = props.isLoading, _$isLoaded = props.isLoaded, dummyList = props.dummyList, _$insertVP = props.insertVP, loading = props.loading, userInfo = props.userInfo, vp1 = props.vp, seoData = props.seoData;
    var generateProductSchema = function() {
        if (!product1) return null;
        var productName = product1 === null || product1 === void 0 ? void 0 : product1.pname;
        var productUrl = "".concat(resources/* SITE_URL */._, "/products/").concat(product1.ename, "/").concat(product1.pcode, "/");
        return {
            "@context": "https://schema.org",
            "@type": "Product",
            name: productName,
            image: product1.main_image,
            description: product1.comment,
            sku: product1.pcode,
            brand: {
                "@type": "Brand",
                name: product1.brand_kor || "\uCE7C\uB81B\uBC14\uC774\uC624"
            },
            offers: {
                "@type": "Offer",
                url: productUrl,
                priceCurrency: "KRW",
                price: product1.discount_price,
                itemCondition: "https://schema.org/NewCondition",
                availability: "https://schema.org/InStock"
            }
        };
    };
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(1), cnt = ref3[0], setCnt = ref3[1];
    var ref4 = (0,react.useState)(false), isAddedWish = ref4[0], setIsAddedWish = ref4[1];
    var ref5 = (0,react.useState)([]), related = ref5[0], setRelated = ref5[1];
    var ref6 = (0,react.useState)([
        false,
        false
    ]), mouseOn = ref6[0], setMouseOn = ref6[1];
    var ref7 = (0,react.useState)(false), openInquiryModal = ref7[0], setOpenInquiryModal = ref7[1];
    var ref8 = (0,react.useState)(false), openLoginModal = ref8[0], setOpenLoginModal = ref8[1];
    var ref9 = (0,react.useState)(false), couponModal = ref9[0], setCouponModal = ref9[1];
    var ref10 = (0,react.useState)(0), activeTab = ref10[0], setActiveTab = ref10[1];
    var tabRef = (0,react.useRef)(null);
    var ref11 = (0,react.useState)(null), brandProducts = ref11[0], setBrandProducts = ref11[1];
    var filterRef = (0,react.useRef)(null);
    // fetch brandproducts
    var fetchBrandProducts = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee(code) {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        body = {
                            modes: "BrandList",
                            code: code
                        };
                        _ctx.next = 4;
                        return (0,products/* ProductsApi */.qO)(body);
                    case 4:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            ;
                            setBrandProducts(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.Rows);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function fetchBrandProducts(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleActiveTab = function(idx) {
        window.scrollTo({
            behavior: "instant",
            left: 0,
            top: tabRef.current.offsetTop
        });
        setActiveTab(idx);
    };
    // 카테고리 필터 클릭 및 스크롤 핸들러
    var handleCategoryFilter = function() {
        // 먼저 필터 초기화
        if (filterRef.current) {
            filterRef.current.handleFilterClick("reset");
        }
        // 현재 탭이 브랜드(2) 또는 옵션(1) 탭이면 다시 상품상세(0)로
        if (activeTab === 1 || activeTab === 2) {
            setActiveTab(0);
        }
        // 약간의 지연 후 새로운 탭으로 전환 및 필터 적용
        setTimeout(function() {
            var targetTab = (product1 === null || product1 === void 0 ? void 0 : product1.brand) ? 2 : 1;
            handleActiveTab(targetTab);
            if (filterRef.current) {
                filterRef.current.setCategory(product1.category_code);
            }
            var filterElement = document.querySelector(".filter-section");
            if (filterElement) {
                filterElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, 100);
    };
    var userCoupon = (0,react.useMemo)(function() {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.Coupon) {
            var ref;
            return userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Coupon) === null || ref === void 0 ? void 0 : ref.rows;
        } else {
            return null;
        }
    }, [
        userInfo
    ]);
    // 장바구니 담기
    var handleCart = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee(product) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product === null || product === void 0 ? void 0 : product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장비구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,auth/* getCookie */.ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 담긴 상태 확인
    var inCart = !(0,auth/* getCookie */.ej)("token") ? cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }) : basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    });
    // 위시리스트 리스트
    var fetchWishList = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee(product) {
            var ref, body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 4;
                        return (0,favorites/* fetchFavorites */.OT)(body);
                    case 4:
                        data = _ctx.sent;
                        if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.find(function(el) {
                            return el.pcode === product.pcode;
                        })) setIsAddedWish(true);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchWishList(product) {
            return _ref.apply(this, arguments);
        };
    }();
    // 위시리스트 등록
    var handleWishlist = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee(product) {
            var body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "InsertSet",
                            pcode: product.pcode
                        };
                        _ctx.next = 3;
                        return (0,favorites/* addFavorites */.IO)(body);
                    case 3:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setIsAddedWish(true);
                            (0,common_alert/* successAlert */.Cq)("\uC704\uC2DC\uB9AC\uC2A4\uD2B8\uC5D0 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4");
                            if (product) {
                                // 채널톡 위시리스트 이벤트
                                window.ChannelIO("track", "AddToWish", {
                                    pcode: product.pcode
                                });
                                dataLayer.push({
                                    ecommerce: null
                                }); // Clear the previous ecommerce object.
                                dataLayer.push({
                                    event: "add_to_wishlist",
                                    ecommerce: {
                                        items: [
                                            {
                                                item_name: product === null || product === void 0 ? void 0 : product.pname,
                                                item_id: product.pcode,
                                                price: product.price,
                                                item_brand: product.supplier,
                                                item_category: product.category_code
                                            }, 
                                        ]
                                    }
                                });
                            }
                        }
                        if (!((data === null || data === void 0 ? void 0 : data.code) === "9999" && (data === null || data === void 0 ? void 0 : data.msg) === "\uD1A0\uD070 \uC815\uBCF4 \uC870\uD68C \uC2E4\uD328")) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", router.push("/login"));
                    case 7:
                        if (!((data === null || data === void 0 ? void 0 : data.code) === "9999")) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)(data === null || data === void 0 ? void 0 : data.msg));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    // 위시리스트 삭제
    var deleteWishlist = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee(product) {
            var body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "DeleteSet",
                            pcode: product.pcode
                        };
                        _ctx.next = 3;
                        return (0,favorites/* deleteFavorites */.fu)(body);
                    case 3:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setIsAddedWish(false);
                            (0,common_alert/* successAlert */.Cq)("\uC704\uC2DC\uB9AC\uC2A4\uD2B8\uC5D0\uC11C \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4");
                        }
                        if (!((data === null || data === void 0 ? void 0 : data.code) === "9999")) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)(data.msg));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteWishlist(product) {
            return _ref.apply(this, arguments);
        };
    }();
    // 이미 담긴 상품 장바구니 버튼 클릭 시 툴팁
    var handleCartBtn = function() {
        if (!mouseOn[0]) {
            setMouseOn([
                true,
                false
            ]);
        }
    };
    // 비회원 바로 구매 모달 오픈
    var handleLoginModal = function() {
        setOpenLoginModal(function(prev) {
            return !prev;
        });
    };
    // 바로 구매하기
    var purchaseDirect = function(product) {
        return function() {
            if (!(0,auth/* getCookie */.ej)("token") && !openLoginModal) {
                handleLoginModal();
                return;
            } else {
                sessionStorage.setItem("directOrder", JSON.stringify([
                    ProductsDetail_objectSpread({}, product, {
                        cnt: cnt
                    })
                ]));
                router.push({
                    pathname: "/checkout",
                    query: {
                        type: "direct"
                    }
                });
            }
        };
    };
    // 관련 상품
    var fetchRelatedProducts = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref15, ref16, ref17, body2, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setCnt(1);
                        body2 = {
                            modes: "HashSet",
                            code: (ref15 = (ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.find(function(el) {
                                return el.name === product1.category_code;
                            })) === null || ref15 === void 0 ? void 0 : ref15.code,
                            hash: ((ref16 = product1.category_tag) === null || ref16 === void 0 ? void 0 : ref16.length) > 0 && product1.category_tag[0]
                        };
                        _ctx.next = 5;
                        return (0,products/* hashSetProducts */.Qz)(body2);
                    case 5:
                        res = _ctx.sent;
                        setRelated((ref17 = res.Data) === null || ref17 === void 0 ? void 0 : ref17.Rows.slice(0, 20));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchRelatedProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // 제작 문의
    var onClickInquiry = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref12 = (0,react.useState)({}), inquiryInputs = ref12[0], setInquiryInputs = ref12[1];
    var onChangeInquiry = function(id) {
        return function(e) {
            if (id.includes("file")) {
                setInquiryInputs(ProductsDetail_objectSpread({}, inquiryInputs, ProductsDetail_defineProperty({}, id, e.target.files[0])));
                return;
            }
            setInquiryInputs(ProductsDetail_objectSpread({}, inquiryInputs, ProductsDetail_defineProperty({}, id, e.target.value)));
        };
    };
    // 문의 완료
    var ref13 = (0,react.useState)(false), openInquiryComplete = ref13[0], setOpenInquiryComplete = ref13[1];
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    // 제작 문의 등록
    var submitInquiry = function() {
        var _ref = ProductsDetail_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.division || !inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.email)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD544\uC218 \uD56D\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        _$isLoading();
                        body = ProductsDetail_objectSpread({
                            modes: "InquirySet",
                            pcode: product1.pcode
                        }, inquiryInputs);
                        _ctx.next = 10;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 10:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            _$isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            _$isLoaded();
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    // ename을 찾는 함수 추가
    var findCategoryEname = function() {
        if (!dummyList || !dummyList.category) return "";
        // 제품의 카테고리 코드로 ename 찾기
        var category = dummyList.category.find(function(cat) {
            return cat.code === product1.category_code || cat.name === product1.category_code;
        });
        return category ? category.ename : "";
    };
    (0,react.useEffect)(function() {
        if (!dummyList) return;
        if (product1 === null || product1 === void 0 ? void 0 : product1.brand) {
            fetchBrandProducts(product1.brand);
        }
        if (product1.pcode) {
            fetchWishList(product1);
            fetchRelatedProducts();
            var ename = findCategoryEname();
            var vp = JSON.parse(sessionStorage.getItem("vp"));
            if (!vp) {
                sessionStorage.setItem("vp", JSON.stringify([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ]));
                _$insertVP([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ]);
            } else if (vp.find(function(el) {
                return el.pcode === product1.pcode;
            })) {
                var idx = vp.findIndex(function(el) {
                    return el.pcode === product1.pcode;
                });
                vp.splice(idx, 1);
                sessionStorage.setItem("vp", JSON.stringify([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ].concat(_toConsumableArray(vp))));
                _$insertVP([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ].concat(_toConsumableArray(vp)));
            } else {
                sessionStorage.setItem("vp", JSON.stringify([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ].concat(_toConsumableArray(vp))));
                _$insertVP([
                    {
                        pname: product1.pname,
                        pcode: product1.pcode,
                        discount_price: product1.discount_price,
                        main_image: product1.main_image,
                        ename: ename
                    }, 
                ].concat(_toConsumableArray(vp)));
            }
        }
        // <!-- ADN Tracker[상품] start -->
        var adnTracker = function() {
            if (window.fn_across_adn_contain) {
                try {
                    var across_adn_item_contain = new fn_across_adn_contain();
                    var across_adn_item_param = [];
                    across_adn_item_param = {
                        ut: "Item",
                        ui: "108274",
                        items: {
                            i: product1.pcode,
                            s: ""
                        }
                    };
                    across_adn_item_contain.init(across_adn_item_param);
                } catch (error) {
                    console.error(error);
                }
            }
        };
        // <!-- ADN Tracker[상품] end -->
        if (product1.pcode) {
            var ref18;
            dataLayer.push({
                ecommerce: null
            }); // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    items: [
                        {
                            item_name: product1.pname,
                            item_id: product1.pcode,
                            price: product1.price,
                            item_brand: product1.supplier,
                            item_category: product1.category_code
                        }, 
                    ]
                }
            });
            var UserAgent = navigator.userAgent;
            var widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
            var wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
            wptg_tagscript_vars.push(function() {
                var ref;
                return {
                    wp_hcuid: (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.id) || "",
                    ti: "54644",
                    ty: "Item",
                    device: widerplanet_device,
                    items: [
                        {
                            i: product1.pcode,
                            t: product1.pname
                        }
                    ]
                };
            });
            (ref18 = globalThis.wptg_tagscript) === null || ref18 === void 0 ? void 0 : ref18.exec();
            adnTracker();
        }
    }, [
        product1,
        dummyList
    ]);
    (0,react.useEffect)(function() {
        var ref, ref20;
        if (!router.isReady) return;
        var handleRouteChange = function() {
            CallMtm();
        };
        window.ENP_VAR = {
            collect: {}
        };
        ENP_VAR.collect.productCode = product1.pcode;
        ENP_VAR.collect.productName = product1.pname;
        ENP_VAR.collect.price = product1.price;
        ENP_VAR.collect.dcPrice = product1.discount_price;
        ENP_VAR.collect.soldOut = product1.sold_out; //Y: 품절제품 or N: 판매제품
        ENP_VAR.collect.imageUrl = product1.main_image;
        ENP_VAR.collect.secondImageUrl = product1.sub_image.length > 0 && product1.sub_image[0] || "";
        ENP_VAR.collect.thirdImageUrl = product1.sub_image.length > 0 && product1.sub_image[1] || "";
        ENP_VAR.collect.fourthImageUrl = product1.sub_image.length > 0 && product1.sub_image[2] || "";
        ENP_VAR.collect.topCategory = (ref20 = (ref = product1.category_code) === null || ref === void 0 ? void 0 : ref.split(",")) === null || ref20 === void 0 ? void 0 : ref20[0];
        ENP_VAR.collect.firstSubCategory = product1.category_tag[0];
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    // ENP 상품 상세
    }, [
        router.isReady,
        product1,
        dummyList
    ]);
    var addPrintCart = function() {
        var tempArr = JSON.parse(sessionStorage.getItem("printCart"));
        if (tempArr) {
            if (tempArr.find(function(el) {
                return el.pcode === product1.pcode;
            })) {
                sessionStorage.setItem("printCart", JSON.stringify(_toConsumableArray(tempArr)));
            } else {
                sessionStorage.setItem("printCart", JSON.stringify([
                    ProductsDetail_objectSpread({}, product1, {
                        cnt: 1
                    })
                ].concat(_toConsumableArray(tempArr))));
            }
        } else {
            sessionStorage.setItem("printCart", JSON.stringify([
                ProductsDetail_objectSpread({}, product1, {
                    cnt: 1
                })
            ]));
        }
        router.push("/customizing/print?tab=product");
    };
    var keywordsString = product1.search_tag ? product1.search_tag.join(", ") : "";
    // product 객체가 유효한지 확인하는 함수
    var isValidProduct = function(product) {
        // 필수 필드 목록 - 제품 스키마에 필요한 핵심 필드들
        var requiredFields = [
            "pcode",
            "ename",
            "category_code"
        ];
        // 모든 필수 필드가 null이 아닌지 확인
        return requiredFields.every(function(field) {
            return product[field] !== null && product[field] !== undefined;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uC0C1\uD488\uAD6C\uB9E4",
            subTitle: product1.category_code,
            subChild: product1.category_tag[0],
            detailsubChild: product1.pname,
            pageTitle: product1.pname,
            pageDesc: product1.comment,
            pageImg: product1.main_image,
            pageKeyword: keywordsString,
            id: product1.ename,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: product1 && isValidProduct(product1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(generateProductSchema())
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "quick-view",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* Container */.W2, {
                            className: "mb-50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* TopWrapper */.Wf, {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6 col-sm-12 col-xs-12 mb-md-0 mb-sm-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* SliderWrapper */.h2, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumb, {
                                                                product: product1,
                                                                url: props.main_image
                                                            }),
                                                            product1.sfnz_view === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct_styles/* SfnzBadge */.L4, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                                                    alt: "SFNZ_badge"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-6 col-sm-12 col-xs-12 mt-10",
                                                    children: product1.view === "N" || product1.view === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "title-wrapper",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(H1Font, {
                                                            children: "\uD310\uB9E4 \uC911\uC9C0\uB418\uC5C8\uAC70\uB098 \uC5C6\uB294 \uC0C1\uD488\uC785\uB2C8\uB2E4."
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* DetailInfo */.x_, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* HeaderWrapper */.Pz, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "title-wrapper",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(H1Font, {
                                                                                children: product1.pname
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                children: product1.comment
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "share-wish-wrapper",
                                                                        children: [
                                                                            isAddedWish ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                "aria-label": "delete To Wishlist",
                                                                                className: "action-btn hover-up",
                                                                                onClick: function(e) {
                                                                                    return deleteWishlist(product1);
                                                                                },
                                                                                style: {
                                                                                    backgroundColor: "#3bb77e",
                                                                                    color: "#fff",
                                                                                    border: "1px solid #3bb77e"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-heart",
                                                                                    style: {
                                                                                        opacity: "1"
                                                                                    }
                                                                                })
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                "aria-label": "Add To Wishlist",
                                                                                className: "action-btn hover-up mobonWish",
                                                                                onClick: function(e) {
                                                                                    return handleWishlist(product1);
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-heart"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                "aria-label": "Share",
                                                                                className: "action-btn hover-up",
                                                                                onClick: function() {
                                                                                    return navigator.clipboard.writeText(globalThis.location.href).then(function() {
                                                                                        return (0,common_alert/* successAlert */.Cq)("\uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                                                                    });
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fi-rs-share"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* CommentWrapper */.Ke, {
                                                                children: ((ref14 = product1.ment) === null || ref14 === void 0 ? void 0 : ref14.find(function(el) {
                                                                    return el !== "";
                                                                })) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "mt-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                            children: " - \uC0C1\uD488 \uC815\uBCF4"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* ProductCommnet */.Go, {
                                                                            children: (ref1 = product1.ment.filter(function(el) {
                                                                                return el !== "";
                                                                            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(el, i) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    children: el
                                                                                }, i);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* PriceWrapper */.vN, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "qty-wrapper",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "detail-qty border radius",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    onClick: function(e) {
                                                                                        return setCnt(cnt > 1 ? cnt - 1 : 1);
                                                                                    },
                                                                                    className: "qty-down",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "fi-rs-angle-small-down"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "qty-val",
                                                                                    children: cnt
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    onClick: function() {
                                                                                        return setCnt(cnt + 1);
                                                                                    },
                                                                                    className: "qty-up",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "fi-rs-angle-small-up"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "price",
                                                                        children: [
                                                                            product1.salePer > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "old-price",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* SalePer */.Jj, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            children: [
                                                                                                product1.salePer,
                                                                                                "%"
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* OldPrice */.rh, {
                                                                                        children: [
                                                                                            (0,splicePrice/* priceComma */.a)(product1.price),
                                                                                            "\uC6D0"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            (product1 === null || product1 === void 0 ? void 0 : product1.discount_price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "discount_price",
                                                                                children: [
                                                                                    (0,splicePrice/* priceComma */.a)(product1 === null || product1 === void 0 ? void 0 : product1.discount_price),
                                                                                    "\uC6D0"
                                                                                ]
                                                                            }),
                                                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "d-flex justify-content-end",
                                                                                children: [
                                                                                    "\uAC1C\uB2F9",
                                                                                    " ",
                                                                                    (0,splicePrice/* priceComma */.a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                                                    "\uC6D0"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* PriceWrapper */.vN, {
                                                                totalPrice: true,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "pricebox-top gap-3",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* SubBtn */.vd, {
                                                                                onClick: handleCategoryFilter,
                                                                                children: [
                                                                                    product1.category_code,
                                                                                    " \uB2E4\uB978 \uC0C1\uD488 \uBCF4\uAE30"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* PointBox */.NF, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "d-flex align-items-center",
                                                                                        children: [
                                                                                            "\uC608\uC0C1\uC801\uB9BD\uAE08 \uCD5C\uB300",
                                                                                            " ",
                                                                                            (0,splicePrice/* priceComma */.a)((0,helper/* calcProdPoint */.tB)(Number(product1.discount_price)) * cnt),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* Sticker */.My, {
                                                                                                children: "P"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                        className: "d-flex align-items-center",
                                                                                        children: [
                                                                                            "\uC801\uB9BD",
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "infoIcon",
                                                                                                onMouseOver: function() {
                                                                                                    return setMouseOn([
                                                                                                        false,
                                                                                                        true
                                                                                                    ]);
                                                                                                },
                                                                                                onMouseLeave: function() {
                                                                                                    return setMouseOn([
                                                                                                        false,
                                                                                                        false
                                                                                                    ]);
                                                                                                },
                                                                                                children: "?"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    mouseOn[1] && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* BtnInfo */.jt, {
                                                                                        className: "info",
                                                                                        children: "\uD3EC\uC778\uD2B8\uB294 \uD560\uC778 \uCFE0\uD3F0 \uC801\uC6A9, \uC635\uC158\uAC00\uACA9, \uC218\uB7C9\uC744 \uAE30\uC900\uC73C\uB85C \uC801\uB9BD\uB418\uBBC0\uB85C \uCD5C\uC885 \uC801\uB9BD \uD3EC\uC778\uD2B8\uB294 \uCFE0\uD3F0 \uC0AC\uC6A9 \uC5EC\uBD80 \uBC0F \uC635\uC158\uAC00\uACA9, \uC218\uB7C9\uC5D0 \uB530\uB77C \uB2EC\uB77C\uC9C8 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "pricebox-bottom",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "title",
                                                                                children: "\uCD5C\uC885 \uAE08\uC561"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "price",
                                                                                children: (product1 === null || product1 === void 0 ? void 0 : product1.discount_price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* DiscountPrice */.oP, {
                                                                                    className: "text-brand",
                                                                                    children: [
                                                                                        (0,splicePrice/* priceComma */.a)((product1 === null || product1 === void 0 ? void 0 : product1.discount_price) * cnt),
                                                                                        "\uC6D0"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* InfoRow */.q$, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* DeliveryComment */.sR, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    children: product1.delivery_type_korea === "\uBB34\uB8CC" ? "\uBB34\uB8CC\uBC30\uC1A1" : product1.delivery_type === "C" ? "\uCC29\uBD88 \uBC30\uC1A1" : "\uBC30\uC1A1\uB8CC : " + product1.delivery_type_korea + " " + (0,splicePrice/* priceComma */.a)(Number(product1 === null || product1 === void 0 ? void 0 : product1.delivery_price) * (product1.bundle === "Y" ? cnt : 1)) + "\uC6D0"
                                                                                })
                                                                            }),
                                                                            product1.deadline > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                                        children: [
                                                                                            product1.deadline,
                                                                                            "\uC2DC"
                                                                                        ]
                                                                                    }),
                                                                                    "\uAE4C\uC9C0 \uC8FC\uBB38\uC2DC \uB2F9\uC77C \uBC1C\uC1A1"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    product1.sold_out === "N" && product1.inquiry === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* MakeBtnWrapper */.Ns, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* CheckoutBtn */.$F, {
                                                                            onClick: onClickInquiry,
                                                                            noMargin: true,
                                                                            children: "\uC81C\uC791 \uBB38\uC758"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* BtnWrapper */.Bo, {
                                                                children: [
                                                                    product1.sold_out === "Y" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* QtyCheckOutBtnWrapper */.C5, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* SoldOut */._R, {
                                                                                children: "\uD488\uC808 \uC0C1\uD488"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* CheckoutBtn */.$F, {
                                                                                inquiry: product1.inquiry,
                                                                                onClick: onClickInquiry,
                                                                                children: "\uC81C\uC791 \uBB38\uC758"
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* QtyCheckOutBtnWrapper */.C5, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "btnBox",
                                                                                children: [
                                                                                    !inCart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* CartBtn */.Eo, {
                                                                                        className: "mobonCart",
                                                                                        onClick: function(e) {
                                                                                            handleCart(ProductsDetail_objectSpread({}, product1, {
                                                                                                cnt: cnt || 1
                                                                                            }));
                                                                                            setMouseOn([
                                                                                                true,
                                                                                                false
                                                                                            ]);
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "d-flex align-items-center justify-content-center",
                                                                                            children: "\uC7A5\uBC14\uAD6C\uB2C8"
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CartBtn */.Eo, {
                                                                                        isStored: true,
                                                                                        onClick: handleCartBtn,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                className: "d-flex align-items-center justify-content-center",
                                                                                                children: "\uC7A5\uBC14\uAD6C\uB2C8"
                                                                                            }),
                                                                                            mouseOn[0] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDetails_styles/* CartTooltip */.vF, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                        className: "text-center tooltip-msg",
                                                                                                        children: "\uC0C1\uD488\uC774 \uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4."
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "btnWrapper",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                                href: "/shop-cart",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                                    className: "btn btn-xs move-cart",
                                                                                                                    children: "\uC7A5\uBC14\uAD6C\uB2C8 \uC774\uB3D9"
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                                                className: "btn btn-xs keep-shopping",
                                                                                                                onClick: function() {
                                                                                                                    return setMouseOn([
                                                                                                                        false,
                                                                                                                        false
                                                                                                                    ]);
                                                                                                                },
                                                                                                                children: "\uACC4\uC18D \uC1FC\uD551\uD558\uAE30"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* CheckoutBtn */.$F, {
                                                                                        onClick: purchaseDirect(ProductsDetail_objectSpread({}, product1, {
                                                                                            cnt: cnt
                                                                                        })),
                                                                                        inquiry: "Y",
                                                                                        noMargin: true,
                                                                                        children: "\uBC14\uB85C \uAD6C\uB9E4"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    product1.smallYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn print-btn",
                                                                        onClick: function() {
                                                                            return addPrintCart();
                                                                        },
                                                                        children: "\uC18C\uB7C9\uC778\uC1C4 \uC2E0\uCCAD"
                                                                    })
                                                                ]
                                                            }),
                                                            product1.sold_out !== "Y" && product1.delivery_type && product1.delivery_code && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* SocialPayWrapper */.nK, {
                                                                children: product1.pcode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Naverpay, {
                                                                    product: product1,
                                                                    cnt: cnt,
                                                                    userDevice: userDevice
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "container",
                                            children: [
                                                product1.related && product1.related.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row mb-20",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "section-title style-1 mb-30",
                                                                children: "\uC5F0\uAD00 \uC0C1\uD488"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "related-products position-relative",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Related, {
                                                                    related: product1.related.map(function(el) {
                                                                        return ProductsDetail_objectSpread({}, el, {
                                                                            pcode: el.plink.split("products/")[1].replace("/", "")
                                                                        });
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "",
                                                    ref: tabRef,
                                                    children: [
                                                        ((product1 === null || product1 === void 0 ? void 0 : (ref2 = product1.options) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 || (product1 === null || product1 === void 0 ? void 0 : product1.brand)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* ProductDetailTabs */.kV, {
                                                            children: [
                                                                "\uC0C1\uD488 \uC0C1\uC138",
                                                                "\uC635\uC158 \uC0C1\uD488",
                                                                "\uBE0C\uB79C\uB4DC \uBC14\uB85C\uAC00\uAE30"
                                                            ].map(function(tab, tabIdx) {
                                                                var ref;
                                                                if (tab === "\uC635\uC158 \uC0C1\uD488" && (product1 === null || product1 === void 0 ? void 0 : (ref = product1.options) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                                                                    return;
                                                                }
                                                                if (tab === "\uBE0C\uB79C\uB4DC \uBC14\uB85C\uAC00\uAE30" && !(product1 === null || product1 === void 0 ? void 0 : product1.brand)) {
                                                                    return;
                                                                }
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* DetailTab */.i3, {
                                                                    active: activeTab === tabIdx,
                                                                    onClick: function() {
                                                                        return handleActiveTab(tabIdx);
                                                                    },
                                                                    children: tab
                                                                }, tabIdx);
                                                            })
                                                        }),
                                                        activeTab === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_ProductTab, {
                                                            product: product1
                                                        }),
                                                        (activeTab === 1 || activeTab === 2) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* OptionProducts */.Au, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter, {
                                                                dummyList: dummyList,
                                                                productList: activeTab === 1 && (product1 === null || product1 === void 0 ? void 0 : product1.options) || activeTab === 2 && brandProducts,
                                                                fixedViewType: "list",
                                                                purchaseDirect: purchaseDirect,
                                                                handleCart: handleCart,
                                                                basketsItems: basketsItems,
                                                                cartItems: cartItems,
                                                                product: product1,
                                                                ref: filterRef
                                                            })
                                                        })
                                                    ]
                                                }),
                                                product1.view !== "N" && product1.view !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row mt-60",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                className: "section-title style-1 mb-30",
                                                                children: "\uD568\uAED8 \uB9CE\uC774 \uBCF8 \uC0C1\uD488"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-12 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "related-products position-relative",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Related, {
                                                                    related: related
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        openInquiryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryModal, {
                            onClickInquiry: onClickInquiry,
                            openInquiryModal: openInquiryModal,
                            submitInquiry: submitInquiry,
                            onChangeInquiry: onChangeInquiry,
                            inquiryInputs: inquiryInputs
                        }),
                        openInquiryComplete && /*#__PURE__*/ (0,jsx_runtime.jsx)(inquiryCompleteModal/* default */.Z, {
                            onClickInquiryComplete: onClickInquiryComplete
                        }),
                        openLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(requestLoginModal/* default */.Z, {
                            handleLoginModal: handleLoginModal,
                            openLoginModal: openLoginModal,
                            purchaseDirect: purchaseDirect,
                            product: product1,
                            cnt: cnt
                        }),
                        couponModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(coupon_couponModal/* default */.Z, {
                            coupons: userCoupon,
                            loading: loading,
                            show: couponModal,
                            setShow: setCouponModal
                        })
                    ]
                })
            ]
        })
    });
};
var ProductsDetail_mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count,
        dummyList: state.dummyList,
        vp: state.vp,
        loading: state.loading.loading,
        userInfo: state.userInfo,
        quickView: state.quickView
    };
};
var ProductsDetail_mapDispatchToProps = {
    addToCart: cart/* addToCart */.Xq,
    increaseCnt: cart/* increaseCnt */.us,
    decreaseCnt: cart/* decreaseCnt */.Yl,
    insertBasketsAction: baskets/* insertBasketsAction */.el,
    fetchBasketsAction: baskets/* fetchBasketsAction */.Ei,
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k,
    insertVP: insertVP,
    closeQuickView: quickViewAction/* closeQuickView */.z
};
/* harmony default export */ var detail_ProductsDetail = ((0,es/* connect */.$j)(ProductsDetail_mapStateToProps, ProductsDetail_mapDispatchToProps)(ProductsDetail));

;// CONCATENATED MODULE: ./pages/products/[slug]/[hash]/index.js





var ProductHashPage = function(param) {
    var product = param.product, seoData = param.seoData, initialPage = param.initialPage, userDevice = param.userDevice, siteConfig = param.siteConfig;
    var ref = useProductPageType(), isDetailPage = ref.isDetailPage, lastSlug = ref.lastSlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isDetailPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(detail_ProductsDetail, {
            seoData: seoData,
            product: product,
            userDevice: userDevice
        }) : //2차 카테고리
        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsList/* default */.Z, {
            seoData: seoData,
            product: product,
            userDevice: userDevice,
            initialPage: initialPage,
            siteConfig: siteConfig
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _hash_ = (ProductHashPage);


/***/ }),

/***/ 75236:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,8427,2511,4948,1111,513,6177,2208,6824,6352,9774,2888,179], function() { return __webpack_exec__(84375); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);